<template lang="pug">
  .DiskLimits
    .DiskLimits-item.Item(v-for="limit in limits")
      .Item-main
        i.Icon(:class="limit.icon")
        span.Indicator(:class="{'Indicator--red': limit.percent <= limit.threshold, 'Indicator--green': limit.percent > limit.threshold}")
      .Item-info.Info(:class="{'Item-info--left': isLeft, 'Item-info--top': isTop, 'Item-info--bottom': isBottom, 'Item-info--right': isRight}")
        .Info-title
          span.Indicator(:class="{'Indicator--red': limit.percent <= limit.threshold, 'Indicator--green': limit.percent > limit.threshold}")
          | {{limit.title}}
        .Info-params
          .Param
            .Param-title Всего
            .Param-value {{limit.total}} {{limit.units}}
          .Param
            .Param-title Свободно
            .Param-value {{limit.remain}} {{limit.units}} ({{limit.percent}}%)
          .Param(v-if="limit.queued_tasks")
            .Param-title Задач в очереди
            .Param-value {{limit.queued_tasks}}
</template>

<script>
  export default {
    name: 'limits',
    props: {
      isTop: {
        type: Boolean,
        default: false,
      },
      isBottom: {
        type: Boolean,
        default: false,
      },
      isLeft: {
        type: Boolean,
        default: false,
      },
      isRight: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.$store.dispatch('getModelingLimits')
    },
    computed: {
      limits() {
        return this.$store.getters.modelingSystemLimits
      }
    }
  }
</script>
<style lang="scss">
  @import "~base";

  #app .DiskLimits,
  .Popup .DiskLimits {
    --background: #{$grey7};
    --tooltipBorder: #{$grey3};
    --indicatorBorder: #{$white};
    --tooltipBg: #{$white};
    --indicatorRed: #{$red};
    --indicatorGreen: #{$green3};
    --infoColor: #{$grey8};
  }

  #app[data-theme='dark'] .DiskLimits,
  .Popup[data-theme='dark'] .DiskLimits  {
    --background: #{$black3};
    --tooltipBorder: #{$grey8};
    --indicatorColor: #{$white};
    --indicatorBorder: #{$white};
    --tooltipBg: #{$black3};
    --indicatorRed: #{$red};
    --indicatorGreen: #{$green3};
    --infoColor: #{$white3};
  }
</style>
<style scoped lang="scss">
  .DiskLimits {
    position: absolute;
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 10px;
    background: var(--background);
    border-radius: 8px;

    &-item {
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }

    .Indicator {
      position: absolute;
      width: 8px;
      height: 8px;
      border: 1px solid var(--indicatorBorder);
      border-radius: 50%;

      &--red {
        background: var(--indicatorRed)
      }
      &--green {
        background: var(--indicatorGreen)
      }
    }

    .Item {
      position: relative;
      width: 20px;
      text-align: center;

      &-main {
        cursor: pointer;

        .Icon {
          font-size: 20px;
          color: var(--secondaryText);
        }

        &:hover {
          .Icon {
            color: var(--basicText);
          }
        }
      }

      .Indicator {
        right: -3px;
        bottom: 0px;
      }

      &:hover {
        .Info {
          display: block;
        }
      }

      &-info {
        position: absolute;
        z-index: 500;

        &--bottom {
          top: 100%;
          margin-top: 10px;

          &:before,
          &:after {
            content: '';
            position: absolute;
            top: -7px;
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-bottom: 7px solid var(--tooltipBorder);
            z-index: 500;
          }

          &:after {
            top: -5px;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid var(--tooltipBg);
            z-index: 501;
          }
        }

        &--right {
          right: 0;
          margin-right: -18px;

          &:before {
            right: 21px;
          }

          &:after {
            right: 23px;
          }
        }

        &--left {
          left: 0;
          margin-left: -18px;

          &:before {
            left: 21px;
          }

          &:after {
            left: 23px;
          }
        }

        &--top {
          bottom: 100%;
          margin-bottom: 10px;


          &:before,
          &:after {
            content: '';
            position: absolute;
            bottom: -7px;
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-top: 7px solid var(--tooltipBorder);
            z-index: 500;
          }

          &:after {
            bottom: -5px;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid var(--tooltipBg);
            z-index: 501;
          }
        }
      }
    }

    .Info {
      display: none;
      width: 200px;
      padding: 15px 18px;
      border: 1px solid var(--tooltipBorder);
      border-radius: 8px;
      background: var(--tooltipBg);
      font-size: 12px;
      color: var(--infoColor);
      text-align: left;

      &-title {
        margin-bottom: 10px;
        position: relative;
        padding-left: 20px;
        font-weight: 500;
      }
      .Indicator {
        top: 50%;
        left: 0;
        margin-top: -4px;
      }
    }

    .Param {
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modeling/Limits.vue